import { ViewEncapsulation } from '@angular/core';
import { EnvironmentEnum, EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  apiUrl: 'https://qs2atesting.amersports.com/api',
  env: EnvironmentEnum.qualification,
  production: true,
  defaultEncapsulation: ViewEncapsulation.None,
};
